export type TExpiredErrorUnit = 'minute' | 'hour' | 'day' | 'month' | 'year'

export class ExpiredError extends Error {
  public readonly amount: number
  public readonly unit: TExpiredErrorUnit

  constructor(message: string, amount: number, unit: TExpiredErrorUnit) {
    super(message)
    this.amount = amount
    this.unit = unit
  }
}
